import { render, staticRenderFns } from "./AgentDetail.vue?vue&type=template&id=0f66283e&scoped=true"
import script from "./AgentDetail.vue?vue&type=script&lang=js"
export * from "./AgentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f66283e",
  null
  
)

export default component.exports